import React, { useState } from "react";
import { Input } from "antd";

const FloatInput = (props) => {
  const [focus, setFocus] = useState(false);
  let { label, value, readOnly, type, starNotRequired = true, required, disabled, onBlur, className, addonAfter, maxLength, defaultValue, onKeyDown } = props;


  const isOccupied = focus || (value && value.length !== 0);

  const labelClass = isOccupied ? " cust-input-label  text-labelGrey text-sm mb-0.5 font-normal label as-label label-field" : "text-labelGrey text-sm mb-0.5 cust-input-label font-normal label as-placeholder label-field";

  const requiredMark = (required && starNotRequired) ? <span className="text-starColor">*</span> : null;

  return (
    <div
      className="relative focus-visible:outline-none flex-1 custom-label-position"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      <label className={labelClass}>
        {label} {requiredMark}
      </label>
      <div>
        <Input
          className={`input-bg pb-0 pt-1 !pl-2 min-h-[46px] !w-full  border-none outline-none  focus:!border-none focus:shadow-none focus:!outline-none focus-within:outline-none focus-visible:!outline-none  rounded-5  placeholder:text-paraColor text-subTextColor ${className}`}
          onChange={props.onChange}
          disabled={disabled}
          readOnly={readOnly}
          type={type}
          defaultValue={defaultValue}
          onBlur={onBlur}
          placeholder={props?.placeholder}
          addonAfter={addonAfter}
          value={value}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
        />
      </div>
    </div>
  );
};

export default FloatInput;
